import React, { useState, useEffect } from 'react';

import { ContentBox } from '../../ContentBox';
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { RespBoard } from '../../../../../item/MyStat/ItemBoard';
import { SubmitButton } from '../../../Res/BaseButton';
import { uuid } from '../../../../../item/ItemTools';
import { setVal2Token } from '../../../../Login/Auth';

export function GameScoreboard({game_id, gameCurrentAll }) {

  const [away_team_name, set_away_team_name] = useState("")
  const [home_team_name, set_home_team_name] = useState("")
  const [board, setBoard] = useState(new RespBoard({}))
  const [inning, set_inning] = useState()
  const [inning_half, set_inning_half] = useState()
  const [defensive_player_number, set_defensive_player_number] = useState("")
  const [defensive_player_name, set_defensive_player_name] = useState("")
  const [offensive_player_number, set_offensive_player_number] = useState("")
  const [offensive_player_name, set_offensive_player_name] = useState("")
  const [current_balls, set_current_balls] = useState(0)
  const [current_strikes, set_current_strikes] = useState(0)
  const [current_outs, set_current_outs] = useState(0)


  useEffect(() => {
    if (gameCurrentAll !== undefined) {
      console.log("gameCurrentAll")
      console.log(gameCurrentAll)
      var mRespBoard = new RespBoard({})
      mRespBoard.fromJson(gameCurrentAll.board)
      try {
        setBoard(mRespBoard)

        set_away_team_name(gameCurrentAll.away_team_name)
        set_home_team_name(gameCurrentAll.home_team_name)

        set_inning(gameCurrentAll.inning)
        set_inning_half(gameCurrentAll.inning_half)

        var plateList = gameCurrentAll.plateList
        if (plateList.length > 0) {
          var plate = plateList[plateList.length - 1]
          if (plate.list.length > 0) {
            var list = plate.list[plate.list.length - 1]
            console.log(list)
            console.log(list.defensive.player.player_number)
            set_defensive_player_number(list.defensive.player.player_number)
            set_defensive_player_name(list.defensive.player.player_name)
            set_offensive_player_number(list.offensive.player.player_number)
            set_offensive_player_name(list.offensive.player.player_name)
          }
        }
        var status = gameCurrentAll.status
        console.log(status)
        set_current_balls(status.current_balls)
        set_current_strikes(status.current_strikes)
        set_current_outs(status.current_outs)
      } catch (err) {
        console.log(err)
       }
    }
  }, [gameCurrentAll])

  function setScore(scores) {
    var td = []
    for (var i = 0; i < 12; i++) {
      var score = scores[i];
      if (score === undefined)
        score = ''
      td.push(<td className="text-center">{score}</td>)
    }
    return td;
  }


  function toActionList() {
    var tokenId = uuid(128, 64)
    setVal2Token("ActionList", {game_id, gameCurrentAll}, tokenId)
    window.location.assign("/Action_List/" + tokenId);
  }


  var title = "計分板"
  var content =
    <>
      <div className="row">
        <div className="col-sm-12">
          <table className="table table-striped table-bordered table-hover  dataTable">
            <thead>
              <tr role="row">
                <th className="text-left sorting col-sm-2">Team</th>
                <th className="text-center sorting">1</th>
                <th className="text-center sorting">2</th>
                <th className="text-center sorting">3</th>
                <th className="text-center sorting">4</th>
                <th className="text-center sorting">5</th>
                <th className="text-center sorting">6</th>
                <th className="text-center sorting">7</th>
                <th className="text-center sorting">8</th>
                <th className="text-center sorting">9</th>
                <th className="text-center sorting">10</th>
                <th className="text-center sorting">11</th>
                <th className="text-center sorting">12</th>
                <th className="text-center sorting">R</th>
                <th className="text-center sorting">H</th>
                <th className="text-center sorting">E</th>
              </tr>
            </thead>
            <tbody>
              <tr role="row">
                <td className="text-left">{away_team_name}</td>
                {setScore(board.away.runs)}
                <td className="text-center">{board.away.R}</td>
                <td className="text-center">{board.away.H}</td>
                <td className="text-center">{board.away.E}</td>

              </tr>
              <tr role="row">
                <td className="text-left">{home_team_name}</td>
                {setScore(board.home.runs)}
                <td className="text-center">{board.home.R}</td>
                <td className="text-center">{board.home.H}</td>
                <td className="text-center">{board.home.E}</td>

              </tr>


            </tbody>
          </table>
        </div>
      </div>
      <div className="row">

        <div className="col-md-12">

          <div className="col-md-2">
            <p>投手：{defensive_player_number} {defensive_player_name}</p>

          </div>

          <div className="col-md-2">
            <p>打者：{offensive_player_number} {offensive_player_name}</p>

          </div>

          <div className="col-md-4">
            <p></p>

          </div>

          <div className="col-md-2">
            <p>紀錄到：{inning}局 {inning_half === 1 ? "上" : "下"}</p>

          </div>

          <div className="col-md-2">
            <p>B:{current_balls} S:{current_strikes} O:{current_outs}</p>

          </div>






        </div>
      </div>
      <div className="row">
        <SubmitButton action={toActionList} name={"ActionList"} icon={"fa-list"} isRight={true} />
      </div>
    </>


  return (
    <>
      <ContentBox title={title} titleSize={6} content={content} hasDrawer={false} />
    </>
  )
}